interface RelatedEntity {
  entityName: string;
  entities: { Id: string; Name: string; Fields: Record<string, unknown> }[];
}

// addressN_* aren't columns on a contact or an account; they come from the related
// customeraddress record with that address number.
function getAddressFieldsByNumber(
  record: Record<string, unknown>,
  addressNumber: string
): Record<string, unknown> | undefined {
  const relatedEntities = record.relatedEntities as RelatedEntity[] | undefined;
  const customerAddresses = relatedEntities?.find(
    (related) => related.entityName === "customeraddress"
  );

  return customerAddresses?.entities.find(
    (address) => String(address.Fields?.addressnumber) === addressNumber
  )?.Fields;
}

const ADDRESS_FIELD_SUFFIXES: Record<string, string> = {
  line1: "line1",
  line2: "line2",
  line3: "line3",
  city: "city",
  county: "county",
  country: "country",
  postalcode: "postalcode",
};

/** A record's customer address with this number as `addressN_*` fields, or null. */
export function getAddressFields(
  record: Record<string, unknown>,
  addressNumber: string
): Record<string, unknown> | null {
  const address = getAddressFieldsByNumber(record, addressNumber);
  if (!address) {
    return null;
  }

  return Object.fromEntries(
    Object.entries(ADDRESS_FIELD_SUFFIXES).map(([suffix, addressField]) => [
      `address${addressNumber}_${suffix}`,
      address[addressField] ?? "",
    ])
  );
}
